<template>
<!--    <div class="col-12_lg-8_md-6_sm-3_xs-1">...</div>-->
    <div class="grid-noGutter">
        <div class="col-1_lg-1_md-12_sm-12_xs-12 filling">заполняет<h2 class="pool-writer">{{getResult.writer}}</h2></div>
        <div class="col-11_lg-11_md-12_sm-12_xs-12">
            <QuestionsHeader :pool="pool"></QuestionsHeader>
        </div>
        <div class="col-1_lg-1_md-12_sm-12_xs-12"></div>
        <div class="col-11_lg-11_md-12_sm-12_xs-12">
            <Questions :questions="pool.questions"></Questions>
        </div>
        <div class="col-1_lg-1_md-12_sm-12_xs-12"></div>
        <div class="col-11_lg-11_md-12_sm-12_xs-12">
            <Assessment :assessment="pool.assessments" :poolindex="poolindex"></Assessment>
        </div>
    </div>
</template>

<script>
    import Questions from '@/components/Questions.vue'
    import Assessment from '@/components/Assessment.vue'
    import QuestionsHeader from '@/components/QuestionsHeader.vue'
    export default {
        name: "Pool",
        props: ['pool', 'poolindex'],
        computed: {
            getResult() {
                return this.$store.getters.Q_ONE
            }
        },
        components: {Questions, Assessment, QuestionsHeader}
    }
</script>

<style scoped>
    .name, .pool-writer {
        text-align: center;
        text-transform: uppercase;
    }

    .pool-writer {
        color: darkred;
    }

    .result, .pool-title {
        text-align: center;
        text-transform: uppercase;
    }

    .filling {
        text-align: left;
    }
</style>